import { Component } from '@angular/core';
import { SessionService } from '../../shared/services/session/session.service';
import { PayoutService } from '../../shared/services/payout/payout.service';
import { TranslationService } from '../../shared/services/translation/translation.service';

@Component({
  selector: 'vit-payout',
  templateUrl: 'payout.component.html',
  styleUrls: ['payout.component.scss']
})
export class PayoutComponent {

  showStakeInput: boolean = false;
  amount: string = '';

  constructor(public sessionService: SessionService,
              public payoutService: PayoutService,
              public translate: TranslationService) {
  }

  setStake(amount: string): void {
    this.amount = amount;
  }

  payout(): void {
    this.payoutService.payout(+this.amount);
  }

  back(): void {
    this.sessionService.showPayout = false;
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/punter-bar/payout/payout.component.ts